<template>
  <VApp>
    <slot />
  </VApp>
</template>

<script setup lang="ts">
import { VApp } from 'vuetify/components/VApp';
</script>
